import Vue from "vue";
import Globals from "../components/globals";
import "whatwg-fetch";
import httpService from "../components/service";
import { store } from "../store/store";
import router from "../router/index";
import user from "@/services/user";
import cacheService from "@/services/cache";

export const setUser = {
    bind(el, binding, vnode) {
        el.addEventListener("click", function(e) {
            check(e);
        });
        el.addEventListener("keypress", function(e) {
            check(e);
        });

        function check(e) {
            let key = e.which || e.keyCode;
            let cookie = document.cookie.split(";");
            let checked = document.getElementById("agree");
            if (checked === null) {
                checked = true;
            }
            if ((key === 13 && binding.modifiers.logEnter === true) || binding.modifiers.login === true) {
                if (cookie.includes("TERMS=Terms Accepted") || checked === true || document.getElementById("agree").checked) {
                    document.cookie = "TERMS = Terms Accepted";
                    Vue.http.options.emulateJSON = true;
                    Vue.http.post(Globals.getBaseUrl() + "/check_login", JSON.stringify(binding.value)).then(response => {
                        if (response.data["code"] === 200) {
                            let token = response.data["token"];
                            let users = response.data.user;
                            let test = { user: users, token: token };
                            let convert = JSON.stringify(test);

                            cacheService.setRem3rchUserAndToken(convert);
                            response.data.user.languages
                                .filter(v => parseInt(v.id) === parseInt(users.preference.activated ? users.preference.language.id : "2"))
                                .map(langue => {
                                    let prefLan = {
                                        id: langue.id,
                                        value: langue.code,
                                        name: langue.name
                                    };
                                    cacheService.set("userLangId", prefLan.id);
                                });

                            let objBrand = users.brands;
                            let objPreference = users.preference;
                            let dataPref = users.preference.activated
                                ? users.preference.brand.id
                                : users.brands[Object.keys(users.brands).shift()].id;
                            filterData(objBrand, dataPref, objPreference);
                            window.location.replace("/");
                        } else {
                            alert("Your username or password are incorrect. Please check your credentials");
                        }
                        return response.data;
                    });
                } else {
                    alert("Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy");
                    return false;
                }
            } else if (binding.modifiers.currentCampaignId === true) {
                cacheService.set("currentCampaignId", binding.value);
                Globals.updatePreferences("campaigns");
            } else if (binding.modifiers.brandId === true) {
                cacheService.set("currentBrandId", binding.value);
                Globals.updatePreferences("brand");
            } else if (binding.modifiers.zoneId === true) {
                cacheService.set("currentZoneId", binding.value);
                Globals.updatePreferences("zones");
            } else if (binding.modifiers.currentStandId === true) {
                cacheService.set("currentStandId", binding.value);
                // Globals.updatePreferences('stand')
            } else if (binding.modifiers.logout === true) {
                user.logout();
            } else if (binding.modifiers.request === true) {
                let method = binding.value[0]; // METHOD
                let url = binding.value[1]; // URL
                let id = binding.value[3]; // ID
                httpService.fetch(method.toString().toUpperCase(), url + id);
            } else if (binding.modifiers.requestCreate === true) {
                let method = binding.value[0]; // METHOD
                let url = binding.value[1]; // URL
                let body = JSON.stringify(binding.value[2]); // BODY
                httpService.fetch(method.toString().toUpperCase(), url, body).then(function(response) {
                    router.push("/plano/" + response);
                    cacheService.set("planoLocked", false);
                    store.dispatch("plano/data/setShowRestore", false);
                    cacheService.set("showRestore", false);
                });
            }
        }
    }
};

/**
 * Function filter by Data
 * @param data
 */
function filterData(objBrand, dataPref, objPreference) {
    let prefBrand = {};
    let prefZone = {};
    let prefStand = {};
    let prefCampaigns = {};
    // console.log('objBrand fn::', objBrand)

    Object.values(objBrand)
        .filter(v => parseInt(v.id) === parseInt(dataPref))
        .map(response => {
            prefBrand = {
                id: response.id,
                name: response.name,
                urlImg: Globals.getBaseUrl() + response.imgPath + response.logo
            };
            if (objPreference.activated) {
                response.zones
                    .filter(v => parseInt(v.id) === parseInt(objPreference.zone.id))
                    .map(response => {
                        prefZone = {
                            id: response.id,
                            name: response.name,
                            abbreviation: response.abbreviation
                        };
                    });
                response.stands
                    .filter(v => parseInt(v.id) === parseInt(objPreference.stand.id))
                    .map(response => {
                        prefStand = {
                            id: response.id,
                            name: response.name
                        };
                        response.campaigns
                            .filter(v => parseInt(v.id) === parseInt(objPreference.campaign.id))
                            .map(response => {
                                prefCampaigns = {
                                    id: response.id,
                                    name: response.name,
                                    shortName: response.shortName
                                };
                            });
                    });
            } else {
                response.zones.map(response => {
                    prefZone = {
                        id: response.id,
                        name: response.name,
                        abbreviation: response.abbreviation
                    };
                });
                response.stands.map(response => {
                    prefStand = {
                        id: response.id,
                        name: response.name
                    };
                    response.campaigns.map(response => {
                        prefCampaigns = {
                            id: response.id,
                            name: response.name,
                            shortName: response.shortName
                        };
                    });
                });
            }
        });
    /**
     * Add DATA localStorage
     */
    cacheService.set("currentBrandId", prefBrand.id);
    cacheService.set("currentZoneId", prefZone.id);
    cacheService.set("currentStandId", prefStand.id);
    cacheService.set("currentCampaignId", prefCampaigns.id ? prefCampaigns.id : "0");
}

Vue.directive("setUserInfo", setUser);



// WEBPACK FOOTER //
// ./src/directives/setUser.js